export default ({
  icon,
}) => ({
  componentName: 'cell-tooltips',
  componentArgs: {
    icon,
  },
});
